<template>
<div class="tech-solution">
    <Navbar />
        <section>
        <div class="container text-left">
            <div class="text text-white">
                <h2>Tech Solution, Website Company Profile</h2>

                <figure class="figure">
                    <a href="https://www.figma.com/file/wZQvYH9ydBfmCtGqTiikdX/Company-Profile-(Final)?node-id=0%3A1" style="font-size: 14px;"><i class="fas fa-link ml-2 mt-5"></i> Visit Design</a>
                    <img src="assets/img/tech-solution.png" class="figure-img img-fluid mt-5" data-aos="flip-left"
                        data-aos-easing="ease-out-cubic" data-aos-duration="2000">
                    <figcaption class="figure-caption mt-3 text-center font-italic text-left">
                        Tech Solution Project Web Design
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>

    <section>
        <div class="container text-left">
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">PROBLEM STATEMENT</h6>
                    <p class="text-desc">To make a great first impression on prospective customers, it is essential to
                        create a company profile design. A company profile is considered as an essential tool for any
                        type of business and can be used as an effective marketing tool to attract new customers as well
                        as investors.
                    </p>
                </div>
            </div>
        </div>
    </section>


    <section>
        <div class="container text-left">
            <h6 class="text-title">PROJECT GOALS</h6>
            <div class="row" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/satu.png" class="mt-5" alt="">
                    <p class="text-desc">Differenciate from competitors<br>through innovation</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/tiga.png" class="mt-5" alt="">
                    <p class="text-desc">Use technology to complement<br>the in company experience</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/dua.png" class="mt-5" alt="">
                    <p class="text-desc">Estabilish trust and credibility<br>through excellent service</p>
                </div>
            </div>
        </div>
    </section>


    <section>
        <div class="container text-left">
            <h6 class="text-title">RESEARCH METHODS</h6>
            <div class="row" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/research.png" class="mt-5" width="11%" alt="">
                    <p class="text-desc">Competitive research</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/Group 44.png" class="mt-5" width="9%%" alt="">
                    <p class="text-desc">UX Survey</p>
                </div>
                <div class="text col-lg-6 col-md-6 col-12">
                    <img src="assets/img/persona.png" class="mt-5" width="10%" alt="">
                    <p class="text-desc">Customer persona</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/userflow.png" class="mt-5" width="13%" alt="">
                    <p class="text-desc">User flow & Journey</p>
                </div>
                <div class="col col-lg-6 col-md-6 col-12">
                    <img src="assets/img/prototype.png" class="mt-5" width="7%" alt="">
                    <p class="text-desc">Prototype testing</p>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">SCOPE AND CONSTRAINTS</h6>
                    <p class="text-desc">Assets that I use from several platforms including for the image I took
                        from <a href="https://www.zara.com/">Unsplash</a>. For icons I took from <a
                            href="https://www.flaticon.com/">flaticons</a>, <a
                            href="https://fontawesome.com/">fontawesome</a> and some I made myself.
                        <br><br> I design the web design for IT Solution and develop it. Then I
                        also design all
                        the inner pages such as
                        home page, about page, and services page.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <figure class="figure mt-5">
                        <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/homepage-tech.png" class="figure-img img-fluid mt-5">
                    </figure>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/style-tech.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
                    <h6 class="text-title">WIREFRAME</h6>
                    <p class="text-desc">I find this wireframe process is very important so I can focus
                        on the content first. I designed the wireframe for all the pages using Figma tools.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/wireframe-techsolution.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container text-left">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">MOCKUP</h6>
                    <p class="text-desc">After finished creating the wireframe in Figma. I continue to the mockup
                        phase. Filling the images, creating some design elements, adding colors, and refining the
                        layout.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <figure class="figure mt-5">
                            <img data-aos="fade-up" data-aos-duration="3000" src="assets/img/mockup-techsolution.png" class="figure-img img-fluid mt-5">
                        </figure>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="container text-left" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
            <div class="row">
                <div class="text col-lg-6 col-md-6 col-12">
                    <h6 class="text-title">RESULT</h6>
                    <p class="text-desc">With some revisions, the final design is finally done. Then the next step is
                        the development process by my self. After about 4 days of design wireframe and visual design. 
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container text-left" data-aos="fade-up" data-aos-duration="3000">
            <figure class="figure mt-5">
                <img src="assets/img/screen-techsolution.png" class="figure-img img-fluid mt-5">
            </figure>
        </div>
    </section>
    <Footer />
</div>
</template>

<script>
import Footer from '../components/Footer.vue'
import Navbar from '../components/NavbarSection.vue'
export default {
    name: 'Tech',
    components: {
        Navbar,
        Footer
    }
}
</script>

<style>
    * {
        font-family: 'Rubik', sans-serif;
    }
    .text-desc {
        color: white !important;
    }
</style>

